import { Navigate } from 'react-router-dom';
import { canAccessClientsModule, isAdminOrAbove } from '../utils/permissions';
import { useAuth } from '../context/AuthContext';

function ClientsRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return null;
  }

  // Clients & Stores: Admins (clients, stores) and whoever may manage client logins.
  if (!canAccessClientsModule(user) && !isAdminOrAbove(user)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}

export default ClientsRoute;
